import { render, staticRenderFns } from "./share-payment-config.vue?vue&type=template&id=035a5d5b&scoped=true"
import script from "./share-payment-config.vue?vue&type=script&lang=js"
export * from "./share-payment-config.vue?vue&type=script&lang=js"
import style0 from "./share-payment-config.vue?vue&type=style&index=0&id=035a5d5b&prod&scoped=true&lang=css"
import style1 from "./share-payment-config.vue?vue&type=style&index=1&id=035a5d5b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035a5d5b",
  null
  
)

export default component.exports